import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Colors } from "../../assets/Colors";
import { MenuBuilder } from "../../components/menu/MenuBuilder";

const MemoPage = () => {
  const navigate = useNavigate();

  let menu = [
    {
      auth: "MemoInternal",
      name: "Memo Internal",
      path: "/memo/internalmemo",
    },
    {
      auth: "MemoInternalAll",
      name: "Internal Memo All",
      path: "/memo/internalmemo-all",
    },
  ];

  let Report = [
    {
      auth: "MemoInternalReport",
      name: "Memo Internal Report",
      path: "/memo/report",
    },
    {
      auth: "MemoInternalReportAll",
      name: "Report All",
      path: "/memo/report-all",
    },
    // ✅ Tambahkan menu baru di bawah ini
    {
      auth: "MemoInternalReportAllImport",
      name: "Report All Import",
      path: "/memo/report-all-import",
    },
  ];

  const [listMenu, setListMenu] = useState(menu);
  const [listReport, setListReport] = useState(Report);

  const filterMenu = (event) => {
    const filtered = menu.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListMenu(filtered);
  };

  const filterReport = (event) => {
    const filtered = Report.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListReport(filtered);
  };

  return (
    <div className="md:ml-64">
      <div className="w-full flex flex-col items-center">
        <div className="w-full px-4 my-4">
          <MenuBuilder
            name="Memo Internal"
            menuController={filterMenu}
            listMenu={listMenu}
          />
          <hr className="border border-main-100 my-6" />
          <MenuBuilder
            name="Report"
            menuController={filterReport}
            listMenu={listReport}
          />
        </div>
      </div>
    </div>
  );
};

export default MemoPage;
